var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../esl-utils/decorators/memoize';
import { SyntheticEventTarget } from '../../esl-utils/dom/events/target';
export class ESLCarouselRendererRegistry extends SyntheticEventTarget {
    constructor() {
        super(...arguments);
        this.store = new Map();
    }
    static get instance() {
        return new ESLCarouselRendererRegistry();
    }
    create(carousel, config) {
        let Renderer = this.store.get(config.type);
        if (!Renderer)
            [Renderer] = this.store.values(); // take first Renderer in store
        return new Renderer(carousel, config);
    }
    register(view) {
        if (!view || !view.is)
            throw Error('[ESL] ESLCarouselRenderer: incorrect registration request');
        if (this.store.has(view.is))
            throw Error(`[ESL] ESLCarouselRenderer: instance with name ${view.is} already defined`);
        this.store.set(view.is, view);
        const detail = { name: view.is, view };
        const event = new CustomEvent('change', { detail });
        this.dispatchEvent(event);
    }
}
__decorate([
    memoize()
], ESLCarouselRendererRegistry, "instance", null);
